import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Search, ArrowRight, Swords } from 'lucide-react';
import { useT } from '../i18n';

/* Compact conversion strip: free scan input + competitor-compare hook.
   Drop it on any page to funnel traffic into Index AI. */
export default function ScanPromo({ className = '' }) {
  const { lang } = useT();
  const isEs = lang === 'es';
  const navigate = useNavigate();
  const [v, setV] = useState('');
  const go = (e) => {
    e.preventDefault();
    navigate(v.trim() ? `/index-ai?scan=${encodeURIComponent(v.trim())}` : '/index-ai#scan');
  };
  return (
    <section className={`px-6 ${className}`} data-testid="scan-promo">
      <div className="max-w-5xl mx-auto rounded-3xl bg-[#0F1116] border border-white/[0.06] px-6 sm:px-10 py-9 sm:py-11">
        <div className="flex flex-col lg:flex-row lg:items-center gap-7">
          <div className="flex-1">
            <p className="text-[11px] tracking-[0.22em] uppercase font-bold text-[#FF9B4A]">
              {isEs ? 'Gratis · Escaneo real en vivo' : 'Free · Real live scan'}
            </p>
            <h3 className="mt-2 text-2xl sm:text-[28px] font-bold text-white leading-tight">
              {isEs ? '¿Sabes realmente cómo te ven Google, ChatGPT y tus clientes?' : 'Do you really know how Google, ChatGPT and your guests see you?'}
            </h3>
            <p className="mt-2 text-[14px] text-neutral-400 leading-relaxed">
              {isEs
                ? 'Tu Kitxens Index AI Score™ en 60 segundos — 30+ chequeos con datos reales. Y si te atreves: compárate con tu competencia.'
                : 'Your Kitxens Index AI Score™ in 60 seconds — 30+ checks on real data. And if you dare: compare yourself against your competition.'}
            </p>
          </div>
          <div className="w-full lg:w-[420px] shrink-0">
            <form onSubmit={go} className="flex flex-col sm:flex-row bg-white rounded-2xl sm:rounded-full p-2 sm:p-1.5 sm:pl-5 items-stretch sm:items-center gap-2 sm:gap-0">
              <div className="flex items-center flex-1 min-w-0 px-3 sm:px-0">
                <Search className="w-4 h-4 text-neutral-400 shrink-0 mr-2" />
                <input value={v} onChange={(e) => setV(e.target.value)} placeholder={isEs ? 'turestaurante.com' : 'yourrestaurant.com'}
                  className="flex-1 h-12 sm:h-10 bg-transparent outline-none text-base sm:text-[14.5px] text-neutral-900 placeholder:text-neutral-400 min-w-0"
                  data-testid="scan-promo-input" />
              </div>
              <button type="submit" className="shrink-0 inline-flex items-center justify-center gap-1.5 bg-[#F77F11] hover:bg-[#d8651a] text-white h-12 sm:h-10 px-5 rounded-xl sm:rounded-full text-[14px] sm:text-[13.5px] font-bold transition-colors" data-testid="scan-promo-submit">
                {isEs ? 'Escanear gratis' : 'Scan free'} <ArrowRight className="w-3.5 h-3.5" />
              </button>
            </form>
            <Link to="/index-ai#compare" className="mt-3 inline-flex items-center gap-1.5 text-[13.5px] font-bold text-[#FF9B4A] hover:text-[#ffb374] transition-colors" data-testid="scan-promo-compare-link">
              <Swords className="w-4 h-4" /> {isEs ? 'O espía a tu competencia y compárate →' : 'Or spy on a competitor and compare →'}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
